// The save-queue lane keys, in one place.
//
// A lane key is a string two unrelated files have to agree on: the page that
// WRITES on it, and any page that waits for that write to land before reading.
// legLane already carried the warning -- "must match the recordKey Trip.jsx
// builds, or a wait here would watch a lane nobody writes to" -- and that
// hazard is the same for every lane. It was surviving on one comment in one
// module while the entry lane was a bare template string in a page and the
// place prefix lived on a third page, which is one hand-typed prefix away from
// a wait that silently watches nothing.
//
// So: every lane key is defined here, and the pages that own them import from
// here. The place waiter is a PREFIX rather than a key because a reader
// (Places.jsx, PlaceVisits.jsx) has no way to know which row the edit page
// touched -- it waits on the whole family.

// A leg reader is a prefix caller too, for the same reason the place one is:
// TripGroup is reached by breadcrumb from the leg page, so it is handed no
// legs and cannot name the lane the edit it is about to read is sitting on.
export const LEG_LANE_PREFIX = 'trip:';

export function legLane(id) {
  return `${LEG_LANE_PREFIX}${id}`;
}

export const ENTRY_LANE_PREFIX = 'entry:';

export function entryLane(id) {
  return `${ENTRY_LANE_PREFIX}${id}`;
}

export const PLACE_LANE_PREFIX = 'place:';

// The item-counter lane. EditHours' ModalEditForm builds the same key from its
// recordKeyPrefix="counter", so the background counter sync
// (itemCounterSync.mjs) serializes behind a hand edit of the same counter
// rather than racing it. Deliberately NOT in RECORD_LANE_PREFIXES: no reader
// waits on a counter write -- the pages that show one repaint through the
// sync's own callback.
export function counterLane(id) {
  return `counter:${id}`;
}

// The lanes a cross-record reader has to wait out: anything whose in-flight
// write would change what it is about to read.
export const RECORD_LANE_PREFIXES = [LEG_LANE_PREFIX, ENTRY_LANE_PREFIX, PLACE_LANE_PREFIX];
